// TODO: Refactor components like this to one Service Wrapper, that enables consumers to be within providers, and outside of layouts etc.
import { useNotificationService } from 'hooks/useNotificationService';

export const NotificationProvider = (): null => {
  useNotificationService();
  return null;
};
